// 方案分类管理
import http from "@/jslibs/axios/http";

// 方案分类列表
export const list = (data) => http.get("/v1/cms/MschemeCategory", data);

// 方案分类新增
export const add = (data) => http.post("/v1/cms/MschemeCategory", data);

// 方案分类编辑
export const edit = ({ uuid, ...data }) => http.put(`/v1/cms/MschemeCategory/${uuid}`, data);

// 方案分类删除
export const del = (data) => http.delete(`/v1/cms/MschemeCategory/${data.cuuid}`);

// 方案分类详情
export const detail = ({ cuuid, ...data }) => http.get(`/v1/cms/MschemeCategory/${cuuid}`, data);
